import { Box, Flex, Heading, Image } from '@chakra-ui/react'
import React from 'react'
import Navbar from '../components/core/Navbar'
import { useColorModeValue } from '../components/ui/color-mode'

const NotFound = () => {
  return (
    <Box>
        <Navbar/>

        <Box px={{'2xl': 8, base: 2}} position={'relative'}>
            <Box
                borderBottom={'1px solid'}
                borderColor={useColorModeValue('gray.100', 'gray.800')}
                w={'full'}
                px={{ '2xl': 10, base: 1 }}
                py={{ '2xl': 6, base: 8 }}
                rounded={40}
                bgGradient={'to-bl'}
                gradientFrom={useColorModeValue('blue.50', 'blue.800')}
                gradientTo={useColorModeValue('purple.50', 'purple.700')}
                h={{ '2xl': '100vh', md: '130vh', base: '100vh' }}
                position={'relative'}
                overflow={'hidden'}
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
                flexDir={'column'}
            >
                <Box textAlign={'center'}>

                    <Heading 
                    bgGradient={'to-bl'}
                    gradientFrom={useColorModeValue('purple.500', 'purple.700')}
                    gradientTo={useColorModeValue('blue.500', 'blue.700')} 
                    fontFamily={'Onest'} 
                    fontSize={{md: '15em', base: '9xl'}}
                    lineHeight={{md: 0.8, base: 'unset'}}
                    bgClip={'text'}
                    >
                        404
                    </Heading> 
                    <Heading fontFamily={'Outfit'} fontSize={'4xl'} mt={{md: 20, base: 8}}>
                        NOT FOUND
                    </Heading>
        
                </Box>




                <Image src={require('../assets/notfound/1.png')} display={{md: 'block', base: 'none'}} position={'absolute'} w={'600px'} top={'-12%'} right={'-8%'} rotate={'180deg'} filter={'blur(10px)'} />
                <Image src={require('../assets/notfound/2.png')} position={'absolute'} display={{md: 'block', base: 'none'}} w={'600px'} bottom={'20%'} left={'-8%'} rotate={'180deg'} filter={'blur(10px)'} />
                
                
            
            
            
            </Box>



            
        </Box>
        
    </Box>
  )
}

export default NotFound